import { render, staticRenderFns } from "./CharacterTalk.vue?vue&type=template&id=c3c91f58&scoped=true&"
import script from "./CharacterTalk.vue?vue&type=script&lang=js&"
export * from "./CharacterTalk.vue?vue&type=script&lang=js&"
import style0 from "./CharacterTalk.vue?vue&type=style&index=0&id=c3c91f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c91f58",
  null
  
)

export default component.exports